export const requireCompleteProfile = process.env.RAZZLE_RUNTIME_COMPLETE_PROFILE_REQUIRED;
